import { render, staticRenderFns } from "./SubmissionReportHeader.vue?vue&type=template&id=76e4e2cf"
import script from "./SubmissionReportHeader.vue?vue&type=script&lang=js"
export * from "./SubmissionReportHeader.vue?vue&type=script&lang=js"
import style0 from "./SubmissionReportHeader.vue?vue&type=style&index=0&id=76e4e2cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports